export function buildCategoryTree(categories) {
  const byId = new Map(
    categories.map((category) => [category.id, { ...category, children: [] }])
  );
  const roots = [];

  byId.forEach((node) => {
    if (node.parentId && byId.has(node.parentId)) {
      byId.get(node.parentId).children.push(node);
      return;
    }
    roots.push(node);
  });

  const sortNodes = (nodes) => {
    nodes.sort((a, b) => a.name.localeCompare(b.name, 'fr'));
    nodes.forEach((node) => sortNodes(node.children));
  };
  sortNodes(roots);

  return roots;
}

export function flattenCategoryTree(nodes, depth = 0) {
  const rows = [];
  nodes.forEach((node) => {
    rows.push({ ...node, depth });
    rows.push(...flattenCategoryTree(node.children || [], depth + 1));
  });
  return rows;
}

export function collectDescendantIds(node) {
  const ids = [];
  (node.children || []).forEach((child) => {
    ids.push(child.id, ...collectDescendantIds(child));
  });
  return ids;
}

export function parentSelectOptions(categories, currentId) {
  const tree = buildCategoryTree(categories);
  const excluded = new Set();

  if (currentId) {
    excluded.add(currentId);
    const current = flattenCategoryTree(tree).find((node) => node.id === currentId);
    if (current) {
      collectDescendantIds(current).forEach((id) => excluded.add(id));
    }
  }

  return flattenCategoryTree(tree).filter((node) => !excluded.has(node.id));
}

export function slugFromName(name) {
  return String(name || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
